// The parts search boxes over the parts tables (add part, part order, part select, parts kit):
// every word typed must appear in some cell of a row. clearPickerSearch() empties a box and its filter.
// Split out of app.js (docs/split-plan.md, session 3). Needs nothing from app.js.


document.getElementById('myPartsInput').addEventListener('input', e => {searchInventory(e)});
document.getElementById('myPartsKitInput').addEventListener('input', e => {searchInventory(e)});

function searchInventory(e) {
  const searchQuery = e.target.value.toLowerCase().trim();
  const tables = ['partsTable', 'partsOrderTable', 'partsSelectTable', 'partsKitTable'];

  const searchTerms = searchQuery.split(' ');

  for (let table of tables) {
    var tableRows = document.querySelectorAll('#' + table + ' tbody tr:not(.header)');

    for (let row of tableRows) {
      const rowCells = row.querySelectorAll('td');
      let matchFound = true;

      for (const searchTerm of searchTerms) {
        let termMatchFound = false;

        for (const cell of rowCells) {
          const cellText = cell.textContent.toLowerCase();

          if (cellText.includes(searchTerm)) {
            termMatchFound = true;
            break;
          }
        }

        if (!termMatchFound) {
          matchFound = false;
          break;
        }
      }

      if (matchFound) {
        row.style.display = 'table-row';
      } else {
        row.style.display = 'none';
      }
    }
  }
}

document.getElementById('myPartsOrderInput').addEventListener('input', searchOrderInventory);

// Empties a parts picker's search box and un-filters its list too: clearing only the text left the
// next opening showing an empty box over a list still cut down to the last search.
export function clearPickerSearch(id) {
  const box = document.getElementById(id);
  if (!box) return;
  box.value = '';
  box.dispatchEvent(new Event('input'));
}

function searchOrderInventory() {
  const searchQuery = document.getElementById('myPartsOrderInput').value.toLowerCase().trim();
  const tables = ['partsOrderTable'];

  const searchTerms = searchQuery.split(' ');

  for (let table of tables) {
    var tableRows = document.querySelectorAll('#' + table + ' tbody tr');

    for (let row of tableRows) {
      const rowCells = row.querySelectorAll('td');
      let matchFound = true;

      for (const searchTerm of searchTerms) {
        let termMatchFound = false;

        for (const cell of rowCells) {
          const cellText = cell.textContent.toLowerCase();

          if (cellText.includes(searchTerm)) {
            termMatchFound = true;
            break;
          }
        }

        if (!termMatchFound) {
          matchFound = false;
          break;
        }
      }

      if (matchFound) {
        row.style.display = 'table-row';
      } else {
        row.style.display = 'none';
      }
    }
  }
}

export function searchGeneralInventory() {
  const searchQuery = document.getElementById('myPartsSelectInput').value.toLowerCase().trim();
  const tables = ['partsSelectTable'];

  const searchTerms = searchQuery.split(' ');

  for (let table of tables) {
    var tableRows = document.querySelectorAll('#' + table + ' tbody tr');

    for (let row of tableRows) {
      const rowCells = row.querySelectorAll('td');
      let matchFound = true;

      for (const searchTerm of searchTerms) {
        let termMatchFound = false;

        for (const cell of rowCells) {
          const cellText = cell.textContent.toLowerCase();

          if (cellText.includes(searchTerm)) {
            termMatchFound = true;
            break;
          }
        }

        if (!termMatchFound) {
          matchFound = false;
          break;
        }
      }

      if (matchFound) {
        row.style.display = 'table-row';
      } else {
        row.style.display = 'none';
      }
    }
  }
}
